import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Mail, Lock, LogIn } from 'lucide-react';
import { toast } from 'sonner';

const AdminLogin = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const result = await login(email, password);

    if (result.success) {
      toast.success('Login successful!');
      navigate('/admin/dashboard');
    } else {
      toast.error(result.error);
    }

    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#0A2463] via-[#0d2d6e] to-[#247BA0] flex items-center justify-center p-4">
      <Card className="w-full max-w-md border-none shadow-2xl">
        <CardHeader className="space-y-4 pb-8">
          <div className="flex justify-center">
            <img 
              src="/company-logo.png" 
              alt="Utkarshudyam Solution" 
              className="h-20 w-auto object-contain"
            />
          </div>
          <CardTitle className="text-3xl font-bold text-center text-[#0A2463]">
            Admin Login
          </CardTitle>
          <p className="text-center text-gray-600">
            Enter your credentials to access admin panel
          </p>
        </CardHeader>

        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <Label htmlFor="email" className="text-[#0A2463] font-semibold flex items-center gap-2">
                <Mail size={18} />
                Email Address
              </Label>
              <Input
                id="email"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="admin@utkarshudyam.com"
                className="mt-2 border-gray-300 focus:border-[#247BA0] focus:ring-[#247BA0]"
              />
            </div>

            <div>
              <Label htmlFor="password" className="text-[#0A2463] font-semibold flex items-center gap-2">
                <Lock size={18} />
                Password
              </Label>
              <Input
                id="password"
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter your password"
                className="mt-2 border-gray-300 focus:border-[#247BA0] focus:ring-[#247BA0]"
              />
            </div>

            <Button
              type="submit"
              disabled={loading}
              className="w-full bg-gradient-to-r from-[#0A2463] to-[#247BA0] hover:from-[#247BA0] hover:to-[#0A2463] text-white py-6 text-lg shadow-lg"
            >
              {loading ? (
                'Logging in...'
              ) : (
                <>
                  <LogIn className="mr-2" size={20} />
                  Login to Admin Panel
                </>
              )}
            </Button>
          </form>

          <div className="mt-6 text-center">
            <Link to="/" className="text-[#247BA0] hover:text-[#0A2463] text-sm">
              ← Back to Website
            </Link>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default AdminLogin;
